import { Injectable } from '@angular/core';
import { add } from 'date-fns';
import { map, Observable, of, tap } from 'rxjs';

import {
  ProviderAvailability,
  PUBLIC_AVAILABILITY_WINDOW_END_DAYS,
  PUBLIC_AVAILABILITY_WINDOW_START_DAYS,
  SchedulingAvailabilityService,
  TimeSlot
} from '@sondermind/data-access/scheduling';

import { IAppointmentSlot } from '../models/public-provider-calendar.interface';

@Injectable({
  providedIn: 'root'
})
export class ProviderCalendarStore {
  private cachedAppointmentSlots: Record<number, IAppointmentSlot[]> = {};

  constructor(private schedulingAvailabilityService: SchedulingAvailabilityService) {}

  getAppointmentSlots$(
    providerPersonaId: number,
    providerTimeZone: string,
    forceRefresh = false
  ): Observable<IAppointmentSlot[]> {
    if (!forceRefresh && this.cachedAppointmentSlots[providerPersonaId]) {
      return of(this.cachedAppointmentSlots[providerPersonaId]);
    }

    const now = new Date();
    const start = add(now, { days: PUBLIC_AVAILABILITY_WINDOW_START_DAYS });
    const end = add(now, { days: PUBLIC_AVAILABILITY_WINDOW_END_DAYS });

    return this.schedulingAvailabilityService
      .getAvailabilityForPublicProviders([providerPersonaId], start, end)
      .pipe(
        map((availability: ProviderAvailability) => {
          const timeSlots: TimeSlot[] = availability.providerSlots.get(providerPersonaId) ?? [];
          return timeSlots.map((ts) => ({
            displayStartTime: ts.start,
            utcStartTime: ts.start,
            utcEndTime: ts.end,
          }));
        }),
        tap((slots) => {
          this.cachedAppointmentSlots[providerPersonaId] = slots;
        })
      );
  }
}
